/**
 * EmailInfiniteScroll — factory for per-sentinel IntersectionObserver.
 *
 * Replaces the inline IntersectionObserver logic in email_list_controller.js.
 * Call attach(el) for each sentinel element; call detach(el) when it leaves the DOM.
 * Call disconnectAll() on teardown.
 */

export class EmailInfiniteScroll {
  constructor() {
    // Map<Element, IntersectionObserver>
    this._observers = new Map()
  }

  /**
   * Attach an IntersectionObserver to a scroll sentinel element.
   * When intersecting, reloads the closest turbo-frame.
   */
  attach(el) {
    if (this._observers.has(el)) return

    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const frame = entry.target.closest('turbo-frame')
          if (frame && frame.src) {
            frame.reload()
          }
        }
      })
    }, { rootMargin: '200px' })

    obs.observe(el)
    this._observers.set(el, obs)
  }

  /**
   * Detach the observer for a sentinel element (called when removed from DOM).
   */
  detach(el) {
    const obs = this._observers.get(el)
    if (obs) {
      obs.disconnect()
      this._observers.delete(el)
    }
  }

  /**
   * Disconnect all observers (called on controller disconnect).
   */
  disconnectAll() {
    this._observers.forEach(obs => obs.disconnect())
    this._observers.clear()
  }
}
